import api from "@services/api";
import axios from "axios";

class MaintenanceService {
  async getStatusMaintenance() {
    try {
      const response = await api.get("/autenticacao/obter-status-manutencao");
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }
}

const maintenanceServiceInstance = new MaintenanceService();
export default maintenanceServiceInstance;
